import { affiliateCookieOptions } from '@shared/constants/storage';
import Cookies from 'js-cookie';

export const useUtmTracking = () => {
  const params = new URLSearchParams(window.location.search);

  const utmSourceFromUrl = params.get('utm_source');
  const utmMediumFromUrl = params.get('utm_medium');
  const utmCampaignFromUrl = params.get('utm_campaign');
  const utmTermFromUrl = params.get('utm_term');
  const utmContentFromUrl = params.get('utm_content');

  if (utmSourceFromUrl) {
    Cookies.set('utm_source', utmSourceFromUrl, affiliateCookieOptions);
  }

  if (utmMediumFromUrl) {
    Cookies.set('utm_medium', utmMediumFromUrl, affiliateCookieOptions);
  }

  if (utmCampaignFromUrl) {
    Cookies.set('utm_campaign', utmCampaignFromUrl, affiliateCookieOptions);
  }

  if (utmTermFromUrl) {
    Cookies.set('utm_term', utmTermFromUrl, affiliateCookieOptions);
  }

  if (utmContentFromUrl) {
    Cookies.set('utm_content', utmContentFromUrl, affiliateCookieOptions);
  }

  const getUtmData = () => ({
    source: Cookies.get('utm_source'),
    medium: Cookies.get('utm_medium'),
    campaign: Cookies.get('utm_campaign'),
    term: Cookies.get('utm_term'),
    content: Cookies.get('utm_content'),
  });

  const destroy = () => {
    Cookies.remove('utm_source', affiliateCookieOptions);
    Cookies.remove('utm_medium', affiliateCookieOptions);
    Cookies.remove('utm_campaign', affiliateCookieOptions);
    Cookies.remove('utm_term', affiliateCookieOptions);
    Cookies.remove('utm_content', affiliateCookieOptions);
  };

  return { getUtmData, destroy };
};
